import { registerPlugin } from '@capacitor/core';

interface PointCraftDeviceSettingsPlugin {
  openAppDetails(): Promise<void>;
  openLocationSettings(): Promise<void>;
}

const PointCraftDeviceSettings = registerPlugin<PointCraftDeviceSettingsPlugin>(
  'PointCraftDeviceSettings'
);

export async function openAndroidAppSettings(): Promise<void> {
  await PointCraftDeviceSettings.openAppDetails();
}

export async function openAndroidLocationSettings(): Promise<void> {
  await PointCraftDeviceSettings.openLocationSettings();
}
